import React, { useState, useEffect } from 'react';
import { Toast } from '@douyinfe/semi-ui';
import { navigate } from '../router';
import { useT } from '../i18n';

const fallbackOrigin = (typeof window !== 'undefined' && window.location) ? window.location.origin : '';

// 协议 tab 文案(走 i18n),label 与 headerHint 用占位符,渲染时调用 t() 替换
//
// 两种协议的 Base URL 形态不同,不能混用:
//   - Anthropic:站点根(不带 /v1)—— 客户端自己拼 /v1/messages
//   - OpenAI:站点根 + /v1 —— 端点是 /v1/chat/completions
const PROTOCOLS = [
  { id: 'claude', labelKey: '指南.Anthropic', headerKey: 'x-api-key', headerHint: '<YOUR_API_KEY>', endpoint: 'POST /v1/messages' },
  { id: 'openai', labelKey: '指南.OpenAI', headerKey: 'Authorization', headerHint: 'Bearer <YOUR_API_KEY>', endpoint: 'POST /v1/chat/completions' },
];

const SetupGuide = () => {
  const t = useT();
  const [active, setActive] = useState('claude');
  const [publicUrl, setPublicUrl] = useState('');
  const [models, setModels] = useState([]);

  useEffect(() => {
    fetch('/api/status')
      .then((r) => r.json())
      .then((j) => {
        const u = (j && j.data && j.data.public_url) || '';
        setPublicUrl(u.replace(/\/+$/, ''));
      })
      .catch(() => {});
    fetch('/api/models')
      .then((r) => r.json())
      .then((j) => {
        const list = (j && j.data) || [];
        if (Array.isArray(list)) setModels(list.filter((x) => x && (x.model || x.name)));
      })
      .catch(() => {});
  }, []);

  const origin = publicUrl || fallbackOrigin;
  const proto = PROTOCOLS.find((p) => p.id === active) || PROTOCOLS[0];
  const baseUrl = active === 'openai' ? origin + '/v1' : origin;

  return (
    <div className="guide-card">
      <div className="guide-card__header">
        <h2 className="guide-card__title">{t('首页.接入说明')}</h2>
      </div>

      <div className="guide-tabs">
        {PROTOCOLS.map((p) => (
          <div
            key={p.id}
            className={`guide-tab ${active === p.id ? 'guide-tab--active' : ''}`}
            onClick={() => setActive(p.id)}
          >
            {t(p.labelKey)}
          </div>
        ))}
      </div>

      <div className="guide-section">
        <div className="guide-section__label">Base URL</div>
        <CopyableText value={baseUrl} />
      </div>

      <div className="guide-section">
        <div className="guide-section__label">Header</div>
        <CopyableText value={`${proto.headerKey}: ${proto.headerHint}`} />
      </div>

      {active === 'claude' && (
        <div className="guide-note">{t('指南.也支持Bearer')}</div>
      )}

      <div className="guide-section">
        <div className="guide-section__label">Endpoint</div>
        <CopyableText value={proto.endpoint} className="guide-section__endpoint" />
      </div>

      {models.length > 0 && (
        <div className="guide-section">
          <div className="guide-section__label">
            {t('指南.BaseURL') === 'Base URL' ? 'Model' : '模型'}
          </div>
          <div className="guide-model-list">
            {models.map((m) => (
              <span
                key={m.model}
                className="guide-model-chip"
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(m.model);
                    Toast.success(t('指南.已复制冒号') + ' ' + m.model);
                  } catch {
                    Toast.warning(t('指南.请手动复制'));
                  }
                }}
                title={`${t('指南.点击复制')}: ${m.model}`}
              >
                <span className="guide-model-chip__name">{m.model}</span>
                {typeof m.rate === 'number' && (
                  <span className="guide-model-chip__rate">×{m.rate}</span>
                )}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="guide-note">
        {t('指南.支持工具')}
      </div>

      <div className="guide-footer">
        <a
          className="guide-cta"
          href="/guide"
          onClick={(e) => { e.preventDefault(); navigate('/guide'); }}
        >
          {t('指南.查看指南')}
        </a>
      </div>
    </div>
  );
};

const CopyableText = ({ value, className }) => {
  const t = useT();
  const handleClick = async (e) => {
    const range = document.createRange();
    range.selectNodeContents(e.currentTarget);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    try {
      await navigator.clipboard.writeText(value);
      Toast.success(t('首页.复制成功'));
    } catch {
      Toast.warning(t('指南.请手动复制'));
    }
  };
  return (
    <div className={className || 'guide-section__code'} onClick={handleClick} title={t('指南.点击复制')}>
      {value}
    </div>
  );
};

export default SetupGuide;